import { render, staticRenderFns } from "./DetailExampleList.vue?vue&type=template&id=70a9253e&scoped=true"
import script from "./DetailExampleList.vue?vue&type=script&lang=js"
export * from "./DetailExampleList.vue?vue&type=script&lang=js"
import style0 from "./DetailExampleList.vue?vue&type=style&index=0&id=70a9253e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9253e",
  null
  
)

export default component.exports